import { useSyncExternalStore } from 'react';

/**
 * Tema claro/oscuro/sistema — port del lib/tema.ts de la landing oficial.
 * Misma clave 'geovis-tema' que la marca madre: la preferencia del usuario en
 * la web es la de «GeoVis» a secas. La clase .dark en <html> la pone también
 * el script anti-FOUC de public/index.html antes del primer paint; aquí solo
 * se mantiene viva tras la hidratación.
 */
const CLAVE = 'geovis-tema';

const oyentes = new Set();
let tema = 'sistema';
try {
  tema = localStorage.getItem(CLAVE) || 'sistema';
} catch {
  /* privacidad extrema del navegador: se queda 'sistema' */
}

const mq = window.matchMedia('(prefers-color-scheme: dark)');

function esOscuro(t) {
  return t === 'oscuro' || (t === 'sistema' && mq.matches);
}

function aplicar() {
  document.documentElement.classList.toggle('dark', esOscuro(tema));
  oyentes.forEach((f) => f());
}

mq.addEventListener('change', aplicar);
aplicar();

export function setTema(t) {
  tema = t;
  try {
    localStorage.setItem(CLAVE, t);
  } catch {
    /* sin persistencia, pero el tema cambia igual */
  }
  aplicar();
}

function suscribir(f) {
  oyentes.add(f);
  return () => oyentes.delete(f);
}

// Constante de módulo: devolver un objeto nuevo aquí rompería useSyncExternalStore (React #185).
let instantanea = { tema, oscuro: esOscuro(tema) };
function leer() {
  if (instantanea.tema !== tema || instantanea.oscuro !== esOscuro(tema)) {
    instantanea = { tema, oscuro: esOscuro(tema) };
  }
  return instantanea;
}

export function useTema() {
  return useSyncExternalStore(suscribir, leer);
}
